"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environment = void 0;
exports.environment = {
    production: true,
    socketUrl: 'wss://contact.callx.com/ws/agents',
    sentryEnvironment: 'production',
    plivo: {
        debug: 'ERROR',
    },
    log: false,
    deepgramApiKey: 'a0936148cae4c24e37__',
    deepgramEphemeralUrl: 'https://copilot.callx.com/api/copilot/deepgram/tokens',
    audioStreamUrl: 'wss://contact.callx.com/ws/audio-stream',
    openAiEphemeralUrl: 'https://copilot.callx.com/api/copilot/tokens',
    rush: {
        convexUrl: 'https://beaming-buffalo-761.convex.cloud',
        apiKey: 'd961bee9b04c06883de6be9d151156ddef1f2123b1222824',
        enabled: true,
    },
};
